import { useState } from 'react'

import { CustomCellEditorProps } from 'ag-grid-react'

import { SearchSelect } from '@fortem-monorepo/react-ui'

import { StrategyIdOptions } from '@/components/dropdowns/StrategyIdOptions'
import { useTradeStrategiesQuery } from '@/react-query/queries/static'

export interface StrategyIdCellEditorProps extends CustomCellEditorProps<{
  strategy_id: number | null
}> {}

export const StrategyIdCellEditor: React.FC<StrategyIdCellEditorProps> = ({
  value,
  onValueChange,
  stopEditing,
}) => {
  const [open, setOpen] = useState(true)

  const query = useTradeStrategiesQuery()

  return (
    <div className={'flex items-center h-full!'}>
      <SearchSelect
        className={'text-xs ag-custom-component-popup w-full min-w-auto! border-0!'}
        open={open}
        setOpen={setOpen}
        value={value?.toString()}
        options={query.data
          ?.map((s) => ({
            label: s.strategy_name,
            value: s.strategy_id?.toString(),
          }))
          .filter((val) => !!val)}
      >
        <StrategyIdOptions
          value={value}
          strategies={query.data}
          onSelect={(val) => {
            onValueChange(val !== null ? val.strategy_id : null)
            setOpen(false)
            stopEditing()
          }}
        />
      </SearchSelect>
    </div>
  )
}
